module.exports = ".device-info {\r\n    background-color: #e8f1f2;\r\n    margin-bottom: 20px;\r\n    text-align: center;\r\n    color: #13293d;\r\n    padding: 20px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/device-info/device-info.component.css
// module id = ./src/app/components/device-info/device-info.component.css
// module chunks = main